class HelperService
  constructor: ($window, $document) ->
    @$window   = $window
    @$document = $document

  getById: (element) ->
    @$document[0].getElementById element

  getByTag: (element) ->
    @$document[0].getElementsByTagName(element)[0]

  css: (el, props) ->
    key = undefined
    for key of props
      `key = key`
      if props.hasOwnProperty(key)
        if key != null
          el.style[key] = props[key]
    el

  setCss: (element, style, value) ->
    element.style[style] = value
    return

  getNodeIndex: (node) ->
    index = 0
    while node = node.previousSibling
      if node.nodeType != 3 or !/^\s*$/.test(node.data)
        index++
    index

  toggle: (element, display) ->
    if typeof display != 'undefined'
      if display
        element.style.display = 'block'
      else
        element.style.display = 'none'
    else
      if element.style.display == 'block'
        element.style.display = 'none'
      else
        element.style.display = 'block'
    element

  #http://jaketrent.com/post/addremove-classes-raw-javascript/

  hasClass: (ele, cls) ->
    ! !ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))

  removeClass: (element, className) ->
    if element and hasClass(element, className)
      reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
      element.className = element.className.replace(reg, '')
    return

  addClass: (element, className) ->
    if element and !hasClass(element, className)
      element.className += ' ' + className
    return

  #http://stackoverflow.com/questions/22100853/dom-pure-javascript-solution-to-jquery-closest-implementation

  closest: (el, fn) ->
    el and (if fn(el) then el else closest(el.parentNode, fn))

  getWindowWidth: ->
    if 'innerWidth' of @$window then @$window.innerWidth else @$document[0].Element.offsetWidth

  getWindowHeight: ->
    if 'innerHeight' of @$window then @$window.innerHeight else @$document[0].Element.offsetHeight

  preventDefault: (event) ->
    if event.preventDefault then event.preventDefault() else (event.returnValue = false)
    return

  addListenerMulti: (el, s, fn) ->
    evts = s.split(' ')
    i = 0
    iLen = evts.length
    while i < iLen
      if @$document[0].addEventListener
        el.addEventListener evts[i], fn, false
      else
        el.attachEvent evts[i], fn, false
        #IE 6/7/8
      i++
    return

  ###*
  * Simulates the animated scrollTop of jQuery. Used when css3:false or scrollBar:true or autoScrolling:false
  * http://stackoverflow.com/a/16136789/1081396
  ###

  scrollTo: (element, to, duration, callback) ->
    start = getScrolledPosition(element)
    change = to - start
    currentTime = 0
    increment = 20
    activeAnimation = true

    animateScroll = ->
      if activeAnimation
        #in order to stope it from other function whenever we want
        val = to
        currentTime += increment
        val = Math.easeInOutCubic(currentTime, start, change, duration)
        setScrolling element, val
        if currentTime < duration
          setTimeout animateScroll, increment
        else if typeof callback != 'undefined'
          callback()
      else if currentTime < duration
        callback()
      return

    animateScroll()
    return

  #http://stackoverflow.com/questions/3464876/javascript-get-@$window-x-y-position-for-scroll

  getScrollTop: ->
    doc = @$document[0].Element
    (@$window.pageYOffset or doc.scrollTop) - (doc.clientTop or 0)

  #http://stackoverflow.com/questions/842336/is-there-a-way-to-select-sibling-nodes

  getChildren: (n, skipMe) ->
    r = []
    while n
      if n.nodeType == 1 and n != skipMe
        r.push n
      n = n.nextSibling
    r

  #Gets siblings

  getAllSiblings: (n) ->
    getChildren n.parentNode.firstChild, n

  next: (element) ->
    nextSibling = element.nextSibling
    while nextSibling and nextSibling.nodeType != 1
      nextSibling = nextSibling.nextSibling
    nextSibling

  prev: (element) ->
    prevSibling = element.previousSibling
    while prevSibling and prevSibling.nodeType != 1
      prevSibling = prevSibling.previousSibling
    prevSibling

  isKeyboardOpen: ->
    if @isTouchDevice
      return @$document[0].activeElement.getAttribute('type') isnt 'text'
    else
      return false

  addHandler: (element, method, normal, oldIE, firefox) ->
    if element.addEventListener
      element.addEventListener normal, method, false
      #IE9, Chrome, Safari, Oper
      if typeof firefox != 'undefined'
        element.addEventListener firefox, method, false
        #Firefox
    else
      element.attachEvent oldIE, method
      #IE 6/7/8
    return

  addResizeHandler: (callback) ->
    @addHandler(@$window, callback, 'resize', 'onresize')

  addScrollHandler: (callback) ->
    @addHandler(@$window, callback, 'scroll', 'onscroll', 'onscroll')

  getQueryStringParameter: (name) ->
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    results = regex.exec(location.search)
    if results == null then '' else decodeURIComponent(results[1].replace(/\+/g, ' '))

  ### --------------- END Javascript helpers  ---------------###

  isTouchDevice: => @$window.navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/)
  isTouch: => (('ontouchstart' in @$window) || (@$window.navigator.msMaxTouchPoints > 0) || (@$window.navigator.maxTouchPoints))

angular
.module("avant.customer_applications.services")
.service "HelperService", [
  "$window",
  "$document",
  HelperService
]

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = HelperService
  exports.HelperService = HelperService
else
  window.HelperService = HelperService
